var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { CalendarEventService } from '@/service/CalendarEventService';
import AppState, { getContacts, setGlobalSlotsAndQuery, } from '@/states/book_appointment';
import { getTimezones, timezones } from '@/utils/timezones';
import { capitalize, isEqual, toLower } from 'lodash';
import moment from 'moment-timezone';
import { computed, reactive, ref } from 'vue';
// Original ref values
const selectedCalendarId = ref('');
const blockedSelectedCalendarId = ref('');
const isUserSelected = ref(false);
const selectedCalendarName = ref('');
const appointmentTitle = ref('');
const blockedOffTitle = ref('');
const appointmentDescription = ref('');
const showDescriptionInput = ref(false);
const selectedCalendarTeamMembers = ref([]);
const isSlotsLoading = ref(false);
const disabledDates = ref([]);
const selectedTeamMember = ref('');
const customStartTime = ref(new Date());
const blockedOffStartTime = ref(new Date());
const isLocationCustom = ref(false);
const locationType = ref('default');
const customizedLocationType = ref('custom');
const customLocation = ref('');
const customEndTime = ref(new Date(+new Date() + 1.8e6));
const blockedOffEndTime = ref(new Date(+new Date() + 1.8e6));
const selectedAppointmentSlot = ref('');
const forceEnableDate = ref(null);
const skipForceEnable = ref(false);
const selectedTimezone = ref(timezones[0].value);
const lastFetchedAppointmentDate = ref('');
const format = 'ddd, MMM Do, YYYY';
const myDatePicker = ref(null);
const oldAppointment = ref();
const appointmentDate = ref(moment().format(format));
const isSettingCalendar = ref(false);
const rruleText = ref('');
const isRRuleLoading = ref(false);
const appointmentStatus = ref('confirmed');
const selectedUser = ref('');
const contactsRef = ref([]);
const guestsRef = ref([]);
const customStartTimePickerKey = ref('');
const customEndTimePickerKey = ref('');
const isRecurring = ref('true');
const recurringEvents = ref([]);
const autoSelectDate = ref('');
const isRecurringEventsLoading = ref(false);
const showAddContactModal = ref(false);
const showRecurringModal = ref(false);
const guestCount = ref(null);
const existingGuestCount = ref(null);
const existingGuest = ref([]);
const serverError = ref('');
const guestCountError = ref('');
const appointmentSlotError = ref('');
const meetingLocationType = ['custom', 'address', 'phone'];
const showCreateAppointmentLoader = ref(false);
const isContactsLoading = ref(false);
const shouldOverrideContactTimezone = ref(false);
const searchContactsQuery = ref('');
const width = ref(0);
const height = ref('');
const apptBooked = ref(false);
const meetingLocation = {
    address: '{{location.full_address}}',
    phone: '{{location.phone}}',
    custom: '',
};
const contactError = ref('');
const slotError = ref('');
const calendarError = ref('');
const appointmentSlots = ref([]);
const selectedUserForCollective = ref();
// Reactive state object
const appointmentWizardState = reactive({
    selectedCalendarId,
    blockedSelectedCalendarId,
    selectedCalendarName,
    appointmentTitle,
    appointmentDescription,
    isUserSelected,
    showDescriptionInput,
    selectedCalendarTeamMembers,
    isSlotsLoading,
    disabledDates,
    selectedTeamMember,
    customStartTime,
    isLocationCustom,
    customizedLocationType,
    customLocation,
    customEndTime,
    selectedAppointmentSlot,
    forceEnableDate,
    skipForceEnable,
    selectedTimezone,
    lastFetchedAppointmentDate,
    format,
    myDatePicker,
    oldAppointment,
    appointmentDate,
    appointmentSlots,
    appointmentStatus,
    selectedUser,
    contactsRef,
    guestsRef,
    customStartTimePickerKey,
    customEndTimePickerKey,
    isRecurring,
    recurringEvents,
    rruleText,
    isRRuleLoading,
    isRecurringEventsLoading,
    showRecurringModal,
    showAddContactModal,
    guestCount,
    existingGuest,
    existingGuestCount,
    serverError,
    appointmentSlotError,
    meetingLocationType,
    meetingLocation,
    showCreateAppointmentLoader,
    locationType,
    guestCountError,
    shouldOverrideContactTimezone,
    isContactsLoading,
    searchContactsQuery,
    contactError,
    slotError,
    calendarError,
    width,
    autoSelectDate,
    apptBooked,
    blockedOffStartTime,
    blockedOffEndTime,
    blockedOffTitle,
    selectedUserForCollective,
    height,
});
export const validateGuestCount = computed(() => {
    return (shouldCollectGuestCountOnly.value &&
        appointmentWizardState.guestCount !== null &&
        (appointmentWizardState.guestCount > 100 ||
            appointmentWizardState.guestCount < 1));
});
export const shouldCollectGuestCountOnly = computed(() => {
    var _a, _b;
    if (isEditingAppointment.value !== '') {
        return (appointmentWizardState.guestCount !== undefined ||
            ((_a = selectedCalendar.value) === null || _a === void 0 ? void 0 : _a.shouldCollectGuestCountOnly));
    }
    return (_b = selectedCalendar.value) === null || _b === void 0 ? void 0 : _b.shouldCollectGuestCountOnly;
});
export const toggleRecurringModal = () => {
    showRecurringModal.value = !showRecurringModal.value;
};
export const bookRecurring = computed(() => {
    return showRecurringSection.value && isRecurring.value === 'true';
});
export const updateAppointmentDate = (date) => {
    appointmentDate.value = date;
};
export const updateStartTime = (date) => {
    isNewBlockSlot.value
        ? (blockedOffStartTime.value = date)
        : (customStartTime.value = date);
};
export const updateEndTime = (date) => {
    isNewBlockSlot.value
        ? (blockedOffEndTime.value = date)
        : (customEndTime.value = date);
};
const isRecurringEnabled = computed(() => {
    return !!(AppState === null || AppState === void 0 ? void 0 : AppState.isRecurringEnabled);
});
export const calendarPageData = computed(() => {
    return AppState === null || AppState === void 0 ? void 0 : AppState.calendarPageData;
});
export const recurringSlots = computed(() => {
    if (!recurringEvents.value.length) {
        return [];
    }
    return recurringEvents.value.map((e) => {
        var _a, _b;
        const endTime = (_a = moment(e.slot)
            .tz(selectedTimezone.value)) === null || _a === void 0 ? void 0 : _a.add(((_b = selectedCalendar.value) === null || _b === void 0 ? void 0 : _b.slotDuration) || 30, 'minutes').format('h:mm a');
        const startTime = moment(e.slot).tz(selectedTimezone.value).format('h:mm a');
        const date = moment(e.slot)
            .tz(selectedTimezone.value)
            .format('ddd, MMMM D, YYYY');
        const startText = moment(e.slot)
            .tz(selectedTimezone.value)
            .format('h:mm a ddd, MMMM D, YYYY');
        const status = e.status === 'AVAILABLE' && e.appointmentStatus === 'confirmed'
            ? 'Confirmed'
            : e.status === 'UNAVAILABLE' && e.appointmentStatus === 'new'
                ? 'Skipped'
                : e.status === 'AVAILABLE' && e.appointmentStatus === 'new'
                    ? 'Unconfirmed'
                    : null;
        return {
            startText: `Starts ${startText}`,
            isUnavailable: e.status !== 'AVAILABLE',
            rangeText: `${date} [${startTime} - ${endTime}]`,
            time: `${startTime} - ${endTime}`,
            statusText: `${date} (${status})`,
        };
    });
});
const showRecurringSection = computed(() => {
    var _a;
    const isRecurringCalendar = ((_a = selectedCalendar.value) === null || _a === void 0 ? void 0 : _a.isRecurringCalendar) &&
        !isEditingAppointment.value &&
        !shouldAllowCustomTime.value;
    return isRecurringEnabled.value && isRecurringCalendar;
});
export const minDate = computed(() => {
    var _a, _b;
    if (isEditingAppointment.value &&
        ((_a = oldAppointment.value) === null || _a === void 0 ? void 0 : _a.startTime) &&
        moment(oldAppointment.value.startTime)
            .tz(selectedTimezone.value)
            .isBefore(moment().tz(selectedTimezone.value))) {
        return moment((_b = oldAppointment.value) === null || _b === void 0 ? void 0 : _b.startTime)
            .tz(selectedTimezone.value)
            .startOf('day')
            .toDate();
    }
    return moment().tz(selectedTimezone.value).startOf('day').toDate();
});
// Computed properties
export const selectedCalendar = computed(() => {
    if (appointmentWizardState.selectedCalendarId) {
        const data = AppState.calendars.find(calendar => calendar.id === appointmentWizardState.selectedCalendarId);
        if (AppState.isEdit && (data === null || data === void 0 ? void 0 : data.shouldCollectGuestInfo)) {
            getContacts();
        }
        return data;
    }
    return null;
});
export const isEditingAppointment = computed(() => {
    return AppState === null || AppState === void 0 ? void 0 : AppState.appointmentToBeEdited;
});
export const isEditingTargetedSlot = computed(() => {
    return (isEditingAppointment.value &&
        appointmentWizardState.appointmentDate ===
            moment(appointmentWizardState.forceEnableDate)
                .tz(appointmentWizardState.selectedTimezone)
                .format(appointmentWizardState.format));
});
export const isNewEvent = computed(() => {
    return !!AppState.isNewEvent;
});
export const isNewBlockSlot = computed(() => {
    return !!AppState.isNewBlockSlot;
});
export const shouldForceAppendDate = computed(() => {
    var _a, _b, _c;
    return (isEditingTargetedSlot.value &&
        (!((_a = selectedCalendar.value) === null || _a === void 0 ? void 0 : _a.isV3Calendar) ||
            ((_b = appointmentWizardState.oldAppointment) === null || _b === void 0 ? void 0 : _b.assignedUserId) ===
                appointmentWizardState.selectedTeamMember) &&
        ((_c = appointmentWizardState.oldAppointment) === null || _c === void 0 ? void 0 : _c.calendarId) ===
            appointmentWizardState.selectedCalendarId);
});
export const globalSlots = computed(() => {
    return AppState === null || AppState === void 0 ? void 0 : AppState.globalSlots;
});
export const shouldAllowCustomTime = computed(() => {
    return AppState === null || AppState === void 0 ? void 0 : AppState.shouldAllowCustomTime;
});
export const hasContact = computed(() => {
    return !!(AppState === null || AppState === void 0 ? void 0 : AppState.selectedContact);
});
export const disableContactTimezone = computed(() => {
    return !!(AppState === null || AppState === void 0 ? void 0 : AppState.disableContactTimezone);
});
export const showCountError = computed(() => {
    return (appointmentWizardState.guestCount !== null &&
        (appointmentWizardState.guestCount > 100 ||
            appointmentWizardState.guestCount < 1));
});
export const contactTimezone = computed(() => {
    var _a;
    return disableContactTimezone.value
        ? AppState.timezone
        : ((_a = AppState === null || AppState === void 0 ? void 0 : AppState.selectedContact) === null || _a === void 0 ? void 0 : _a.timezone) || AppState.timezone;
});
const locationTimezone = computed(() => {
    return (AppState === null || AppState === void 0 ? void 0 : AppState.timezone) || 'UTC';
});
export const computedTimezonesNew = computed(() => {
    let timezoneOptions = getTimezones(AppState.calendarPageData.startTime).map(timezone => {
        return {
            label: timezone.label,
            value: timezone.value,
        };
    });
    const contactTimezoneOption = timezoneOptions.find(timezone => timezone.value == contactTimezone.value);
    const locationTimezoneOption = timezoneOptions.find(timezone => timezone.value == locationTimezone.value);
    const systemTimezoneOption = timezoneOptions.find(timezone => timezone.value == moment.tz.guess());
    timezoneOptions = timezoneOptions.filter(timezone => timezone.value != (contactTimezoneOption === null || contactTimezoneOption === void 0 ? void 0 : contactTimezoneOption.value) &&
        timezone.value != (locationTimezoneOption === null || locationTimezoneOption === void 0 ? void 0 : locationTimezoneOption.value) &&
        timezone.value != (systemTimezoneOption === null || systemTimezoneOption === void 0 ? void 0 : systemTimezoneOption.value));
    const recommendedOptions = [];
    if (contactTimezoneOption &&
        !disableContactTimezone.value &&
        hasContact.value) {
        if (recommendedOptions.findIndex(x => x.value === (contactTimezoneOption === null || contactTimezoneOption === void 0 ? void 0 : contactTimezoneOption.value)) === -1) {
            recommendedOptions.push({
                label: `${contactTimezoneOption === null || contactTimezoneOption === void 0 ? void 0 : contactTimezoneOption.label}`,
                value: contactTimezoneOption === null || contactTimezoneOption === void 0 ? void 0 : contactTimezoneOption.value,
            });
        }
    }
    if (locationTimezoneOption) {
        if (recommendedOptions.findIndex(x => x.value === (locationTimezoneOption === null || locationTimezoneOption === void 0 ? void 0 : locationTimezoneOption.value)) === -1) {
            recommendedOptions.push({
                label: `${locationTimezoneOption === null || locationTimezoneOption === void 0 ? void 0 : locationTimezoneOption.label}`,
                value: locationTimezoneOption === null || locationTimezoneOption === void 0 ? void 0 : locationTimezoneOption.value,
            });
        }
    }
    if (systemTimezoneOption) {
        if (recommendedOptions.findIndex(x => x.value === (systemTimezoneOption === null || systemTimezoneOption === void 0 ? void 0 : systemTimezoneOption.value)) === -1) {
            recommendedOptions.push({
                label: `${systemTimezoneOption === null || systemTimezoneOption === void 0 ? void 0 : systemTimezoneOption.label}`,
                value: systemTimezoneOption === null || systemTimezoneOption === void 0 ? void 0 : systemTimezoneOption.value,
            });
        }
    }
    return [
        {
            type: 'group',
            label: 'Recommended Timezones',
            key: 'recommended',
            children: recommendedOptions,
        },
        {
            type: 'group',
            label: 'All Timezones',
            key: 'all',
            children: timezoneOptions,
        },
    ];
});
const globalSlotsQuery = computed(() => {
    return AppState === null || AppState === void 0 ? void 0 : AppState.globalSlotsQuery;
});
export const slotInContactTimezone = computed(() => {
    var _a, _b;
    if (shouldAllowCustomTime.value) {
        let startTime = moment(customStartTime.value)
            .tz(selectedTimezone.value, true)
            .tz(contactTimezone.value || selectedTimezone.value);
        let endTime = moment(customEndTime.value)
            .tz(selectedTimezone.value, true)
            .tz(contactTimezone.value || selectedTimezone.value);
        if (startTime.format('YYYY-MM-DD') === endTime.format('YYYY-MM-DD')) {
            startTime = startTime.format('MMM D, h:mm a');
            endTime = endTime.format('h:mm a');
        }
        else {
            startTime = startTime.format('MMM D, h:mm a');
            endTime = endTime.format('MMM D, h:mm a');
        }
        return {
            startTime,
            endTime,
        };
    }
    let startTime = moment(selectedAppointmentSlot.value)
        .tz(selectedTimezone.value, true)
        .tz(contactTimezone.value || selectedTimezone.value);
    let endTime = (_a = moment(selectedAppointmentSlot.value)
        .tz(selectedTimezone.value, true)
        .tz(contactTimezone.value || selectedTimezone.value)) === null || _a === void 0 ? void 0 : _a.add(((_b = selectedCalendar.value) === null || _b === void 0 ? void 0 : _b.slotDuration) || 30, 'minutes');
    if (startTime.format('YYYY-MM-DD') === endTime.format('YYYY-MM-DD')) {
        startTime = startTime.format('MMM D, h:mm a');
        endTime = endTime.format('h:mm a');
    }
    else {
        startTime = startTime.format('MMM D, h:mm a');
        endTime = endTime.format('MMM D, h:mm a');
    }
    return {
        startTime,
        endTime,
    };
});
export const setSelectedTeamMember = (value) => {
    if (selectedTeamMember.value !== value) {
        locationType.value = 'default';
        customizedLocationType.value = 'custom';
    }
    selectedTeamMember.value = value;
    fetchSlots(false);
};
export const fetchSlots = (isFirstFetch = true) => __awaiter(void 0, void 0, void 0, function* () {
    autoSelectDate.value = '';
    if (!selectedCalendarId.value ||
        shouldAllowCustomTime.value ||
        AppState.isLoading) {
        return;
    }
    if (appointmentDate.value === 'Invalid date') {
        appointmentDate.value = moment().format(format);
    }
    const selectedDate = moment(appointmentDate.value, format).tz(selectedTimezone.value, true);
    const startDate = selectedDate.clone().startOf('month');
    const endDate = selectedDate.clone().endOf('month');
    const freeSlotQuery = {
        calendarId: selectedCalendarId.value,
        startDate: startDate.valueOf(),
        endDate: endDate.valueOf(),
        userId: selectedTeamMember.value === 'default' ? null : selectedTeamMember.value,
        timezone: selectedTimezone.value,
        ignoreDateRange: true,
    };
    if (globalSlots.value &&
        isEqual(freeSlotQuery, globalSlotsQuery.value) &&
        !isSlotsLoading.value) {
        setAppointmentSlots(globalSlots.value);
        return;
    }
    disabledDates.value = [];
    isSlotsLoading.value = true;
    const { data } = yield CalendarEventService.getFreeSlots(freeSlotQuery);
    console.log('autoSelectDateStart: ', autoSelectDate.value);
    isSlotsLoading.value = false;
    let firstEnabledDate = null;
    for (let index = 1; index <= moment(appointmentDate.value, format).daysInMonth(); index++) {
        const momentDay = moment(appointmentDate.value, format).set({
            date: index,
        });
        if (!data[momentDay.format('YYYY-MM-DD')] &&
            moment(forceEnableDate.value)
                .tz(selectedTimezone.value)
                .startOf('day')
                .local()
                .format(format) !== momentDay.local().format(format)) {
            disabledDates.value.push(momentDay.local().toDate());
        }
        else if (!firstEnabledDate) {
            firstEnabledDate = momentDay.local().toDate();
        }
    }
    if (firstEnabledDate && isFirstFetch) {
        if (isEditingAppointment.value &&
            forceEnableDate.value &&
            moment(forceEnableDate.value)
                .tz(selectedTimezone.value)
                .local()
                .format('YYYY-MM') === moment(firstEnabledDate).format('YYYY-MM')) {
            autoSelectDate.value = moment(forceEnableDate.value)
                .tz(selectedTimezone.value)
                .format('YYYY-M-D');
            console.log('autoSelectDateIf: ', autoSelectDate.value);
            appointmentDate.value = moment(forceEnableDate.value)
                .tz(selectedTimezone.value)
                .format(appointmentWizardState.format);
            skipForceEnable.value = true;
        }
        else {
            autoSelectDate.value = moment(firstEnabledDate).format('YYYY-M-D');
            appointmentDate.value = moment(firstEnabledDate).format(appointmentWizardState.format);
            console.log('autoSelectDateElse: ', autoSelectDate.value);
        }
    }
    setGlobalSlotsAndQuery(data, freeSlotQuery);
    setAppointmentSlots(data);
});
const setAppointmentSlots = (data) => {
    var _a;
    appointmentSlots.value = [];
    let slots = ((_a = data[moment(appointmentDate.value, format).format('YYYY-MM-DD')]) === null || _a === void 0 ? void 0 : _a.slots) ||
        [];
    if (shouldForceAppendDate.value) {
        slots.push(moment(forceEnableDate.value).tz(selectedTimezone.value).format());
    }
    slots = slots.sort(function (left, right) {
        return moment(left)
            .tz(selectedTimezone.value)
            .diff(moment(right).tz(selectedTimezone.value));
    });
    //make slots unique
    slots = [...new Set(slots)];
    appointmentSlots.value = slots.map(slot => {
        var _a;
        return {
            label: moment(slot).tz(selectedTimezone.value).format('h:mm a') +
                ' - ' +
                moment(slot)
                    .tz(selectedTimezone.value)
                    .add(((_a = selectedCalendar.value) === null || _a === void 0 ? void 0 : _a.slotDuration) || 30, 'minutes')
                    .format('h:mm a'),
            value: moment(slot)
                .tz(selectedTimezone.value)
                .format('YYYY-MM-DDTHH:mm:ss'),
        };
    });
    if (appointmentSlots.value.length > 0 && !isEditingTargetedSlot.value) {
        selectedAppointmentSlot.value = appointmentSlots.value[0].value;
    }
    else if (isEditingTargetedSlot.value) {
        selectedAppointmentSlot.value = moment(forceEnableDate.value)
            .tz(selectedTimezone.value)
            .format('YYYY-MM-DDTHH:mm:ss');
        if (appointmentSlots.value.length > 0 &&
            !appointmentSlots.value.find(slot => slot.value === selectedAppointmentSlot.value)) {
            selectedAppointmentSlot.value = appointmentSlots.value[0].value;
        }
    }
};
export const teamMemberOptions = computed(() => {
    if (!appointmentWizardState.selectedCalendarTeamMembers) {
        return [];
    }
    let memberOptions = appointmentWizardState.selectedCalendarTeamMembers.map(teamMember => {
        return {
            label: teamMember.userName,
            value: teamMember.userId,
        };
    });
    memberOptions = memberOptions.sort((a, b) => {
        if (a.label < b.label) {
            return -1;
        }
        if (a.label > b.label) {
            return 1;
        }
        return 0;
    });
    if (shouldAllowCustomTime.value) {
        return [...memberOptions];
    }
    return [
        {
            label: 'Calendar Default',
            value: 'default',
        },
        ...memberOptions,
    ];
});
// Function to get rcurring events text
export const fetchRRuleText = () => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    rruleText.value = '';
    const rrule = (_a = selectedCalendar.value) === null || _a === void 0 ? void 0 : _a.recurring;
    if (showRecurringSection.value && (rrule === null || rrule === void 0 ? void 0 : rrule.freq)) {
        isRRuleLoading.value = true;
        const { data } = yield CalendarEventService.generateRRuleText({
            freq: rrule.freq,
            interval: rrule.interval,
            count: rrule.count,
            weekDays: rrule.weekDays,
            monthDays: rrule.monthDays,
        });
        rruleText.value = capitalize(toLower(data.replace('time', 'day')));
        isRRuleLoading.value = false;
    }
});
// Function to set the selected calendar and related data
export const setSelectedCalendar = (e, fetchSlot = true) => __awaiter(void 0, void 0, void 0, function* () {
    var _b, _c, _d, _e, _f, _g;
    // Update the selected calendar ID based on the selected value
    selectedCalendarId.value = e.value;
    // Set loading indicator while setting the calendar
    isSettingCalendar.value = true;
    // Check if the selected calendar has team members
    if (selectedCalendar.value && selectedCalendar.value.teamMembers) {
        // Map and update selected calendar's team members with user names
        selectedCalendarTeamMembers.value = (_b = selectedCalendar.value) === null || _b === void 0 ? void 0 : _b.teamMembers.map((teamMember) => {
            var _a;
            return (Object.assign(Object.assign({}, teamMember), { userName: (_a = AppState.users.find(user => user.id === teamMember.userId)) === null || _a === void 0 ? void 0 : _a.name }));
        });
        // Filter out team members without user names and deselected team members
        selectedCalendarTeamMembers.value =
            selectedCalendarTeamMembers.value.filter(teamMember => teamMember.userName && teamMember.selected !== false);
        // Update customized location type if no team members are selected
        if (selectedCalendarTeamMembers.value.length === 0) {
            customizedLocationType.value = 'custom';
        }
        if (selectedCalendar.value.isCollectiveBookingCalendar) {
            const collectiveAddressMember = ((_d = (_c = selectedCalendar.value) === null || _c === void 0 ? void 0 : _c.teamMembers.find(x => x.useMeetingForCollective)) === null || _d === void 0 ? void 0 : _d.userId) ||
                ((_f = (_e = selectedCalendar.value) === null || _e === void 0 ? void 0 : _e.teamMembers.find(x => x.isPrimary)) === null || _f === void 0 ? void 0 : _f.userId);
            customizedLocationType.value = 'custom';
            selectedUserForCollective.value = collectiveAddressMember;
        }
        // Determine the selected team member based on conditions
        if (!isEditingAppointment.value) {
            selectedTeamMember.value = 'default';
        }
        else if (((_g = oldAppointment.value) === null || _g === void 0 ? void 0 : _g.assignedUserId) &&
            selectedCalendarTeamMembers.value.find(teamMember => { var _a; return teamMember.userId === ((_a = oldAppointment.value) === null || _a === void 0 ? void 0 : _a.assignedUserId); })) {
            selectedTeamMember.value = oldAppointment.value.assignedUserId;
        }
        else if (teamMemberOptions.value.length > 0) {
            selectedTeamMember.value = teamMemberOptions.value[0].value;
        }
        else {
            selectedTeamMember.value = 'default';
        }
    }
    // Fetch RRule text if the recurring section is shown
    showRecurringSection.value && (yield fetchRRuleText());
    appointmentWizardState.guestCount = AppState.isEdit ? undefined : null;
    appointmentWizardState.guestsRef = [];
    // Fetch available slots after updating the calendar
    if (fetchSlot)
        yield fetchSlots();
    // Clear loading indicator after setting the calendar
    isSettingCalendar.value = false;
});
// Function to fetch recurring events based on selected slot and timezone
export const fetchRecurringEvents = () => __awaiter(void 0, void 0, void 0, function* () {
    // Clear existing recurring events and set loading indicator
    recurringEvents.value = [];
    isRecurringEventsLoading.value = true;
    // Calculate the start of the selected appointment slot in the selected timezone
    const slotStart = moment(selectedAppointmentSlot.value)
        .tz(selectedTimezone.value, true)
        .format();
    // Convert the slot start time to a timestamp
    const selectedSlot = new Date(slotStart).getTime();
    // Prepare parameters for the API request
    const params = {
        selectedSlot,
        timezone: selectedTimezone.value,
    };
    try {
        // Fetch recurring events using CalendarEventService
        const { data } = yield CalendarEventService.getRecurringSlot(selectedCalendarId.value, params);
        // Update the recurringEvents array with fetched data
        recurringEvents.value = data;
        // Clear loading indicator
        isRecurringEventsLoading.value = false;
    }
    catch (error) {
        console.log('error: ', error);
        // isRecurringEventsLoading.value = false
    }
});
export const shouldCollectGuestInfo = computed(() => {
    var _a, _b;
    if (isEditingAppointment.value !== '') {
        return (appointmentWizardState.guestsRef.length > 0 ||
            (appointmentWizardState.guestCount === undefined &&
                ((_a = selectedCalendar.value) === null || _a === void 0 ? void 0 : _a.shouldCollectGuestInfo)));
    }
    return (_b = selectedCalendar.value) === null || _b === void 0 ? void 0 : _b.shouldCollectGuestInfo;
});
// Function to generate calendar dropdown options
export const calendarDropDownOptions = (isBlockSlot) => {
    var _a, _b;
    // Get the calendars from AppState
    let _calendars = AppState.calendars;
    // Filter out inactive calendars
    if (isBlockSlot) {
        _calendars = AppState.calendars.filter(calendar => {
            return calendar.isActive && calendar.isEventCalendar;
        });
    }
    else {
        _calendars = AppState.calendars.filter(calendar => {
            return calendar.isActive;
        });
    }
    if (isEditingAppointment.value) {
        if ((_a = oldAppointment.value) === null || _a === void 0 ? void 0 : _a.webinarId) {
            _calendars = _calendars.filter(calendar => calendar.isClassBookingCalendar);
        }
        else if ((_b = oldAppointment.value) === null || _b === void 0 ? void 0 : _b.assignedUserId) {
            _calendars = _calendars.filter(calendar => {
                var _a;
                return calendar.id === ((_a = oldAppointment.value) === null || _a === void 0 ? void 0 : _a.calendarId) ||
                    (calendar.isV3Calendar && !calendar.isClassBookingCalendar);
            });
        }
        else {
            _calendars = _calendars.filter(calendar => {
                var _a;
                return calendar.id === ((_a = oldAppointment.value) === null || _a === void 0 ? void 0 : _a.calendarId) ||
                    !calendar.isV3Calendar;
            });
        }
    }
    // Extract unique calendar categories (providerIds) from active calendars
    let calendarCategories = _calendars
        .filter(calendar => calendar.providerId)
        .map(calendar => calendar.providerId);
    // Remove duplicates using Set
    calendarCategories = [...new Set(calendarCategories)];
    // Map calendarCategories to corresponding team details
    calendarCategories = calendarCategories.map((calendarCategory) => {
        const team = AppState.teams.find(team => calendarCategory === team.id);
        if (team) {
            return {
                id: team.id,
                name: team.name,
            };
        }
        return undefined;
    });
    // Remove undefined values from calendarCategories
    calendarCategories = calendarCategories.filter((calendarCategory) => calendarCategory);
    // Filter out unassigned calendars
    const unassignedCalendars = _calendars.filter(calendar => {
        return !calendar.providerId;
    });
    // Prepend 'UnAssigned' option if there are unassigned calendars
    if (unassignedCalendars.length > 0) {
        calendarCategories.unshift({
            id: 'unassigned',
            name: 'Unassigned',
        });
    }
    // Generate dropdown options with groups
    const masterOptions = calendarCategories.map((calendarCategory) => {
        return {
            type: 'group',
            label: calendarCategory.name,
            key: calendarCategory.id,
            children: _calendars
                .filter(calendar => calendarCategory.id === 'unassigned'
                ? !calendar.providerId // Filter unassigned calendars
                : calendar.providerId === calendarCategory.id // Filter by calendar category
            )
                .map(calendar => {
                return {
                    key: calendar.id,
                    label: calendar.name,
                    value: calendar.id, // Value to be used when selected
                };
            }),
        };
    });
    return masterOptions; // Return the generated dropdown options
};
export const getLocationTzTimezone = (value) => {
    const timezoneDifference = moment.tz(moment.tz.guess()).utcOffset() -
        moment.tz(appointmentWizardState.selectedTimezone).utcOffset();
    return moment(value).subtract(timezoneDifference, 'minutes');
};
export const resetAppointmentWizardState = () => {
    appointmentWizardState.selectedCalendarId = '';
    appointmentWizardState.blockedSelectedCalendarId = '';
    appointmentWizardState.isUserSelected = false;
    appointmentWizardState.selectedCalendarName = '';
    appointmentWizardState.appointmentTitle = '';
    appointmentWizardState.blockedOffTitle = '';
    appointmentWizardState.appointmentDescription = '';
    appointmentWizardState.showDescriptionInput = false;
    appointmentWizardState.selectedCalendarTeamMembers = [];
    appointmentWizardState.isSlotsLoading = false;
    appointmentWizardState.disabledDates = [];
    appointmentWizardState.selectedTeamMember = '';
    appointmentWizardState.customStartTime = new Date();
    appointmentWizardState.blockedOffStartTime = new Date();
    appointmentWizardState.isLocationCustom = false;
    appointmentWizardState.locationType = 'default';
    appointmentWizardState.customizedLocationType = 'custom';
    appointmentWizardState.customLocation = '';
    appointmentWizardState.customEndTime = new Date(+new Date() + 1.8e6);
    appointmentWizardState.blockedOffEndTime = new Date(+new Date() + 1.8e6);
    appointmentWizardState.selectedAppointmentSlot = '';
    appointmentWizardState.forceEnableDate = null;
    appointmentWizardState.skipForceEnable = false;
    appointmentWizardState.selectedTimezone = timezones[0].value;
    appointmentWizardState.lastFetchedAppointmentDate = '';
    appointmentWizardState.myDatePicker = null;
    appointmentWizardState.oldAppointment = '';
    appointmentWizardState.appointmentDate = moment().format(format);
    appointmentWizardState.rruleText = '';
    appointmentWizardState.isRRuleLoading = false;
    appointmentWizardState.appointmentStatus = 'confirmed';
    appointmentWizardState.selectedUser = '';
    appointmentWizardState.contactsRef = [];
    appointmentWizardState.guestsRef = [];
    appointmentWizardState.customStartTimePickerKey = '';
    appointmentWizardState.customEndTimePickerKey = '';
    appointmentWizardState.isRecurring = 'true';
    appointmentWizardState.recurringEvents = [];
    appointmentWizardState.isRecurringEventsLoading = false;
    appointmentWizardState.showAddContactModal = false;
    appointmentWizardState.showRecurringModal = false;
    appointmentWizardState.guestCount = null;
    appointmentWizardState.existingGuestCount = null;
    appointmentWizardState.existingGuest = [];
    appointmentWizardState.serverError = '';
    appointmentWizardState.appointmentSlotError = '';
    appointmentWizardState.showCreateAppointmentLoader = false;
    appointmentWizardState.appointmentSlots = [];
    appointmentWizardState.shouldOverrideContactTimezone = false;
    appointmentWizardState.guestCountError = '';
    appointmentWizardState.isContactsLoading = false;
    appointmentWizardState.contactError = '';
    appointmentWizardState.slotError = '';
    appointmentWizardState.calendarError = '';
    appointmentWizardState.apptBooked = false;
};
// Export the appointmentWizardState object
export { appointmentWizardState };
